import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectDriversConfiguration } from './ProjectDriversConfiguration';
import { ProjectDriversInputField, ProjectDriversValueField } from './ProjectDriversEntityField';
import {
  ProjectDriversReportCancelType,
  ProjectDriversReportCompleteType,
  ProjectDriversStopCanceledSpecificFieldsType,
  ProjectDriversStopCompletedSpecificFieldsType,
  ProjectDriversStopFieldsType,
  ProjectDriversStopSpecificFieldsType,
  ProjectDriversTaskCancelSpecificFieldsType,
  ProjectDriversTaskCancelType,
  ProjectDriversTaskCompleteSpecificFieldsType,
  ProjectDriversTaskCompleteType,
  ProjectDriversTaskSpecificFieldsType,
  ProjectDriversTaskType,
} from './ProjectDriversFields';

export interface ProjectDriversProps {
  configuration: ProjectDriversConfiguration[];
  stop_fields: Array<ProjectDriversValueField<ProjectDriversStopFieldsType>>;
  task_fields: Array<ProjectDriversValueField<ProjectDriversTaskType>>;
  task_completed_fields: Array<ProjectDriversInputField<ProjectDriversTaskCompleteType>>;
  task_canceled_fields: Array<ProjectDriversInputField<ProjectDriversTaskCancelType>>;
  stop_completed_fields: Array<ProjectDriversInputField<ProjectDriversReportCompleteType>>;
  stop_canceled_fields: Array<ProjectDriversInputField<ProjectDriversReportCancelType>>;
}

export class ProjectDrivers extends ValueObject<ProjectDriversProps> {
  get configuration() {
    return this.props.configuration;
  }

  set configuration(configuration: ProjectDriversConfiguration[]) {
    this.props.configuration = configuration;
  }

  configHasField(fieldId: ProjectDriversConfiguration) {
    return Boolean(this.props.configuration.find((field) => field === fieldId));
  }

  get stop_fields() {
    return this.props.stop_fields;
  }

  set stop_fields(stop_fields: Array<ProjectDriversValueField<ProjectDriversStopFieldsType>>) {
    this.props.stop_fields = stop_fields;
  }

  stopFieldsHasSpecificField(fieldId: ProjectDriversStopSpecificFieldsType) {
    return Boolean(this.props.stop_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  stopCustomFields() {
    return this.props.stop_fields.filter((field) => field.is_custom_field);
  }

  stopHasCustomField(fieldId: string) {
    return Boolean(this.stopCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  get task_fields() {
    return this.props.task_fields;
  }

  set task_fields(task_fields: Array<ProjectDriversValueField<ProjectDriversTaskType>>) {
    this.props.task_fields = task_fields;
  }

  taskFieldsHasSpecificField(fieldId: ProjectDriversTaskSpecificFieldsType) {
    return Boolean(this.props.task_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  taskCustomFields() {
    return this.props.task_fields.filter((field) => field.is_custom_field);
  }

  taskHasCustomField(fieldId: string) {
    return Boolean(this.taskCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  get task_completed_fields() {
    return this.props.task_completed_fields;
  }

  set task_completed_fields(task_completed_fields: Array<ProjectDriversInputField<ProjectDriversTaskCompleteType>>) {
    this.props.task_completed_fields = task_completed_fields;
  }

  taskCompletedFieldsHasSpecificField(fieldId: ProjectDriversTaskCompleteSpecificFieldsType) {
    return Boolean(this.props.task_completed_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  taskCompletedCustomFields() {
    return this.props.task_completed_fields.filter((field) => field.is_custom_field);
  }

  taskCompletedHasCustomField(fieldId: string) {
    return Boolean(this.taskCompletedCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  get task_canceled_fields() {
    return this.props.task_canceled_fields;
  }

  set task_canceled_fields(task_canceled_fields: Array<ProjectDriversInputField<ProjectDriversTaskCancelType>>) {
    this.props.task_canceled_fields = task_canceled_fields;
  }

  taskCanceledFieldsHasSpecificField(fieldId: ProjectDriversTaskCancelSpecificFieldsType) {
    return Boolean(this.props.task_canceled_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  taskCanceledCustomFields() {
    return this.props.task_canceled_fields.filter((field) => field.is_custom_field);
  }

  taskCanceledHasCustomField(fieldId: string) {
    return Boolean(this.taskCanceledCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  get stop_completed_fields() {
    return this.props.stop_completed_fields;
  }

  set stop_completed_fields(stop_completed_fields: Array<ProjectDriversInputField<ProjectDriversReportCompleteType>>) {
    this.props.stop_completed_fields = stop_completed_fields;
  }

  stopCompletedFieldsHasSpecificField(fieldId: ProjectDriversStopCompletedSpecificFieldsType) {
    return Boolean(this.props.stop_completed_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  stopCompletedCustomFields() {
    return this.props.stop_completed_fields.filter((field) => field.is_custom_field);
  }

  stopCompletedHasCustomField(fieldId: string) {
    return Boolean(this.stopCompletedCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  get stop_canceled_fields() {
    return this.props.stop_canceled_fields;
  }

  set stop_canceled_fields(stop_canceled_fields: Array<ProjectDriversInputField<ProjectDriversReportCancelType>>) {
    this.props.stop_canceled_fields = stop_canceled_fields;
  }

  stopCanceledFieldsHasSpecificField(fieldId: ProjectDriversStopCanceledSpecificFieldsType) {
    return Boolean(this.props.stop_canceled_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  stopCanceledCustomFields() {
    return this.props.stop_canceled_fields.filter((field) => field.is_custom_field);
  }

  stopCanceledHasCustomField(fieldId: string) {
    return Boolean(this.stopCanceledCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  private constructor(props: ProjectDriversProps) {
    super(props);
  }

  static create(props: ProjectDriversProps): ProjectDrivers {
    return new ProjectDrivers(props);
  }
}
